import React from 'react';
import UnfulfilledWarehouseOrders from '../../../components/shared/UnfulfilledWarehouseOrders';
import { getRegularOrdersColumns } from '../../../components/shared/UnfulfilledWarehouseColumns';

const UnfulfilledWarehouseOrdersPage = () => {
  return (
    <UnfulfilledWarehouseOrders
      apiEndpoint="/orders/unfulfilled-warehouse"
      linkBasePath="/orders"
      pageTitle="Unfulfilled by Warehouse"
      breadcrumbTitle="Orders"
      getColumns={getRegularOrdersColumns}
    />
  );
};

export default UnfulfilledWarehouseOrdersPage; 
